import React, { useEffect, useState } from "react";
// import "./libraryBox.css";
import Checkbox from "@mui/material/Checkbox";
import { grey, orange } from "@mui/material/colors";
import { Tooltip } from "@mui/material";
import SourceLibrary from "../../Enum/SourceLibraryEnum";
import { toast } from "react-toastify";
import { BookOpen, CalendarDays, ClipboardList, Lightbulb } from "lucide-react";
import axios from "../../axios";

const LibraryBox = ({
  question,
  selectedQuestion,
  setSelectedQuestion,
  setSelQueID,
  assessmentDetails,
  sourceLibrary,
  componentType,
  libraryQuestions,
  isSelectChecked,
  hideSelectBox,
  questionTypeMap,
}) => {
  const [questionTypeByB4STypeId, setQuestionTypeByB4STypeId] = useState({});

  useEffect(() => {
    let b4sQuestionTypes = {};

    Object.values(questionTypeMap || {}).forEach((val) => {
      if (
        val?.b4sQuestionType !== undefined &&
        b4sQuestionTypes[val.b4sQuestionType] === undefined
      ) {
        b4sQuestionTypes[val.b4sQuestionType] = val;
      }
    });

    setQuestionTypeByB4STypeId(b4sQuestionTypes);
  }, [questionTypeMap]);

  console.log("questionTypeByB4STypeId", questionTypeByB4STypeId);

  const uniqueId = `${question.title}_${question.chapter?.id}_${question.type?.id}`;

  const isChecked =
    sourceLibrary === SourceLibrary.FROM_AI_LIBRARY
      ? selectedQuestion.some((q) => q.id === uniqueId)
      : selectedQuestion.some(
          (q) => q.id === question.id || q.b4sQuestion === question.id,
        );

  console.log("selected questions ", selectedQuestion);

  const handleAddingQuestion = (isChecked) => {
    if (isChecked) {
      if (sourceLibrary === SourceLibrary.FROM_AI_LIBRARY) {
        setSelectedQuestion((prev) => [
          ...prev,
          {
            id: uniqueId,
            standard_id: question?.standard?.id,
            subject_id: question?.subject?.id,
            section_id: question?.section?.id,
            book_id: question?.book?.id,
            chapter_id: question?.chapter?.id,
            type_id: question?.type?.id,
            question_type: question?.type?.is_manually_graded
              ? "true"
              : "false",
            domain_id: question?.domain?.id,
            skill_id: question?.skill?.id,
            difficulty_level: question?.difficulty_level?.id,
            title: question?.title,
            correct_score: question?.correct_score,
            is_mandatory: question?.is_mandatory,
            add_to: "all",
            add_to_mock: false,
            attachments: question?.attachments,
            options: question?.options,
            correct_answers: question?.correct_answers,
            is_question_edited: false,
            question: question,
          },
        ]);
      }
      const isDup = selectedQuestion.some((que) => que.id === question.id);
      if (isDup) {
      } else {
        if (sourceLibrary == SourceLibrary.FROM_SCHOOL_LIBRARY) {
          setSelQueID((prev) => [...prev, question.id]);
          localStorage.setItem(`isChecked_${question.id}`, "true");

          setSelectedQuestion((prev) => [
            ...prev,
            {
              id: question?.id,
              standard_id: question?.standard?.id || question?.standard_id?.id,
              subject_id: question?.subject?.id || question?.subject_id?.id,
              section_id: question?.section?.id || question?.section_id?.id,
              book_id: question?.book?.id || question?.book_id?.id,
              chapter_id: question?.chapter?.id || question?.chapter_id?.id,
              type_id: question?.type?.id || question?.type_id?.id,
              question_type:
                question?.type?.is_manually_graded === true ||
                question?.type_id?.isManuallyGraded === true
                  ? "true"
                  : "false",
              domain_id: question?.domain?.id || question?.domain_id?.id,
              skill_id: question?.skill?.id || question?.skill_id?.id,
              difficulty_level: question?.difficulty_level?.id,
              title: question?.title,
              correct_score: question?.correct_score,
              is_mandatory: question?.is_mandatory,
              add_to: "all",
              add_to_mock: false,
              attachments: question?.attachments,
              options: question?.options,
              correct_answers: question?.correct_answers,
              is_question_edited: false,
              question: question,
            },
          ]);
        } else if (sourceLibrary == SourceLibrary.FROM_B4S_LIBRARY) {
          if (questionTypeByB4STypeId[question?.type?.id]["id"] === undefined) {
            toast.error("Oops.. Server Couldn't Process Data Successfuly.");
            return false;
          }
          setSelQueID((prev) => [...prev, question.id]);
          localStorage.setItem(`isChecked_${question.id}`, "true");

          setSelectedQuestion((prev) => [
            ...prev,
            {
              b4sQuestion: question?.id,
              standard_id: assessmentDetails?.standard_id?.id,
              subject_id: assessmentDetails?.subject_id?.id,
              section_id: assessmentDetails?.section_id?.id,
              book_id: question?.book?.id,
              chapter_id: question?.chapter?.id,
              type_id: questionTypeByB4STypeId[question?.type?.id]["id"],
              question_type: question?.type?.is_manually_graded
                ? "true"
                : "false",
              domain_id: question?.domain?.id,
              skill_id: question?.skill?.id,
              difficulty_level: question?.difficulty_level?.id,
              title: question?.title,
              correct_score: question?.correct_score,
              is_mandatory: question?.is_mandatory,
              add_to: "all",
              add_to_mock: false,
              attachments: question?.attachments,
              options: question?.options,
              correct_answers: question?.correct_answers,
              is_question_edited: false,
              question: question,
            },
          ]);
        }
      }
    } else {
      if (sourceLibrary === SourceLibrary.FROM_AI_LIBRARY) {
        setSelectedQuestion((prev) => {
          return prev.filter((item) => item.id !== uniqueId);
        });
      } else {
        localStorage.removeItem(`isChecked_${question.id}`);
        if (sourceLibrary === SourceLibrary.FROM_SCHOOL_LIBRARY) {
          setSelectedQuestion((prev) =>
            prev.filter(
              (item) =>
                item.id !== question.id && item.b4sQuestion !== question.id,
            ),
          );
          setSelQueID((prev) => {
            return prev.filter((item) => item !== question.id);
          });
        } else if (sourceLibrary === SourceLibrary.FROM_B4S_LIBRARY) {
          setSelectedQuestion((prev) =>
            prev.filter(
              (item) =>
                item.id !== question.id && item.b4sQuestion !== question.id,
            ),
          );
          setSelQueID((prev) => {
            return prev.filter((item) => item !== question.id);
          });
        }
      }
    }
  };

  const timeHelper = (a) => {
    const dateObj = new Date(a);
    const day = dateObj.getUTCDate();
    const month = dateObj.getUTCMonth() + 1;
    const year = dateObj.getUTCFullYear();
    const outputDateString = `${day}/${month}/${year}`;
    return outputDateString;
  };

  return (
    <>
      <div
        className="p-3 rounded-3"
        style={{
          backgroundColor: "#fde8cc",
          borderRight: "3px solid #007bff",
          width: "250px",
          minHeight: "190px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
          fontFamily: "'Poppins', sans-serif",
        }}
      >
        {/* Title */}
        <div
          className="align-items-center poppins-semibold text-dark d-flex gap-2"
          style={{ minHeight: "48px" }} // set consistent height
        >
          {/* Icon aligned to top */}
          <div style={{ flexShrink: 0 }}>
            <Lightbulb size={20} color="#000" />
          </div>

          {/* Text (2-line ellipsis with fixed height) */}
          <Tooltip
            title={question?.title}
            arrow
            placement="top"
            enterDelay={200}
            leaveDelay={100}
          >
            <div
              className="text-truncate"
              style={{
                display: "-webkit-box",
                WebkitLineClamp: 2,
                WebkitBoxOrient: "vertical",
                overflow: "hidden",
                textOverflow: "ellipsis",
                lineHeight: "1.3em",
                height: "2.6em", // ensures 2-line space
                paddingTop: "11px",
              }}
            >
              {question?.title}
            </div>
          </Tooltip>
        </div>

        {/* Line 1: Domain | Skill | Type */}
        <div className="mb-1  gap-2  small d-flex align-items-center poppins-semibold">
          <ClipboardList size={20} color="#000" className="me-1" />{" "}
          {/* Board */}
          {(question?.domain?.name || question?.domain_id?.name) ?? "-"} |{" "}
          {(question?.skill?.name || question?.skill_id?.name) ?? "-"} |{" "}
          {(question?.type?.name || question?.type_id?.name) ?? "-"}
        </div>

        {/* Line 2: Difficulty | Book : Chapter */}
        <div
          className="d-flex gap-2 poppins-semibold text-dark"
          style={{ minHeight: "48px", alignItems: "flex-start" }}
        >
          {/* Top-aligned icon */}
          <div style={{ flexShrink: 0, paddingTop: "2px" }}>
            <BookOpen size={20} color="#000" />
          </div>

          {/* 2-line ellipsis text */}
          <div
            className="small poppins-semibold"
            style={{
              display: "-webkit-box",
              WebkitLineClamp: 2,
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
              textOverflow: "ellipsis",
              lineHeight: "1.3em",
              height: "2.6em", // ensures 2-line space
            }}
          >
            {question?.difficulty_level?.name ?? "-"} |{" "}
            {(question?.book?.name || question?.book_id?.name) ?? "-"} :{" "}
            {(question?.chapter?.chapterName ||
              question?.chapter_id?.chapterName) ??
              "-"}
          </div>
        </div>

        {/* Footer: Date + Checkbox */}

        <div
          className={`d-flex ${
            sourceLibrary === "FROM_AI_LIBRARY"
              ? "justify-content-end"
              : "justify-content-between"
          }  align-items-center`}
        >
          {sourceLibrary !== "FROM_AI_LIBRARY" && (
            <div className="d-flex align-items-center gap-2">
              <CalendarDays size={20} color="#000" /> {/* Calendar */}
              <div className=" small">
                {question?.created_at && (
                  <small className="poppins-semibold">
                    {timeHelper(question?.created_at)}
                  </small>
                )}
              </div>
            </div>
          )}
          <Checkbox
            checked={isChecked}
            onChange={(e) => handleAddingQuestion(e.target.checked)}
            className="m-0 p-0"
            sx={{
              color: grey[500],
              "&.Mui-checked": {
                color: orange[800],
              },
            }}
          />
        </div>
      </div>
    </>
  );
};

export default LibraryBox;
